import { action, observable } from "mobx";
import { Logger } from "bernie-logger";
import { SerializedData, Store } from "bernie-core";
import { ViewCompositionNode } from "react-view-composer";
import { Composition, Template } from "src/typings/flexFramework/FlexDefinitions";
import {
  moduleDefinitionToViewCompositionNode,
  flexComponentToViewCompositionNode,
} from "src/stores/ViewComposerStore";

export class ViewComposerStore extends Store {
  @observable
  public viewComposition: ViewCompositionNode[];

  /* istanbul ignore next */
  public constructor(state: SerializedData = {}, logger: Logger) {
    super(state, logger);
  }

  /* istanbul ignore next */
  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  @action
  public setup(structureInput: Template | Composition) {
    const isComposition = (structure: Template | Composition): structure is Composition => {
      return !!(structure as Composition).page;
    };

    this.viewComposition = this.viewComposition ?? [];

    if (isComposition(structureInput)) {
      structureInput.page.regionList.forEach((flexComponent) => {
        this.viewComposition.push(flexComponentToViewCompositionNode(flexComponent));
      });
    } else {
      structureInput.regions.forEach((moduleDefinition) => {
        this.viewComposition.push(moduleDefinitionToViewCompositionNode(moduleDefinition));
      });
    }
  }
}
